import { render, staticRenderFns } from "./BoInquiry.vue?vue&type=template&id=b297319a&"
import script from "./BoInquiry.vue?vue&type=script&lang=js&"
export * from "./BoInquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports